import actionTypes from './actionTypes';
import PlayerSource from '../../sources/player';
import { fetchManifest } from '../../sources/flow-library';
import { addNotification } from './notification';
import { notificationTypes } from '../../constants';

/**
 *
 * @param {object} flowToInstall An object describing the flow to be installed from the library (defined in the manifest)
 * @param {string} currentTenantId The tenant ID of the teant the user is currently logged into.
 * @param {string} authenticationToken
 */
export const installPlayer = (flowToInstall, currentTenantId, authenticationToken) => async (dispatch) => {

    let newPlayer;
    const { name, tenantId } = flowToInstall.preferredPlayer;

    try {
        const player = await PlayerSource.get(name, tenantId);

        // Save the player inside the current tenant
        newPlayer = await PlayerSource.save(name, encodeURIComponent(player), currentTenantId, authenticationToken);

    } catch (error) {
        dispatch(addNotification({
            type: notificationTypes.ERROR,
            message: error.message,
            isPersistent: true,
        }));
    }

    return newPlayer;
};

/* eslint-disable import/prefer-default-export */
export const fetchFlowLibraryItems = () => async (dispatch) => {

    let flows = [];

    dispatch({
        type: actionTypes.FLOW_LIBRARY_LOADING,
    });

    try {

        flows = await fetchManifest();

    } catch (error) {

        dispatch(addNotification({
            type: 'error',
            message: 'Cannot retrieve Flows from library',
        }));
    }

    dispatch({
        type: actionTypes.FLOW_LIBRARY_SET,
        payload: flows,
    });
};
